<script lang="ts" setup>
// Properties
const props = defineProps({
    type: {
        type: String,
        default: "button",
    },
    px: {
        type: String,
        default: "px-6",
    },
    py: {
        type: String,
        default: "py-2.5",
    },
});

// Data
</script>

<template>
    <NuxtLink
        v-if="type.toLowerCase() === 'link'"
        class="bg-primary hover:bg-abc-blue focus:border-abc-blue focus:text-abc-blue active:text-abc-blue inline-block rounded-full border-2 border-white text-center text-white no-underline! focus:bg-white focus:ring-1 focus:ring-offset-1 active:border-white active:bg-white disabled:border-gray-400 disabled:text-gray-400 dark:ring-offset-white"
        :class="px + ' ' + py"
    >
        <slot></slot>
    </NuxtLink>
    <button
        v-else
        :type="type"
        class="hover:bg-abc-blue focus:border-abc-blue focus:text-abc-blue active:text-abc-blue rounded-full border-2 border-white text-center font-semibold text-white focus:bg-white focus:ring-1 focus:ring-offset-1 active:border-white active:bg-white disabled:border-gray-400 disabled:text-gray-400 dark:ring-offset-white"
        :class="px + ' ' + py"
    >
        <slot></slot>
    </button>
</template>
